// Generated by https://quicktype.io
//
// To change quicktype's target language, run command:
//
//   "Set quicktype target language"

export interface EventData
{
    data: EventDetails[];
    total: number;
}

export interface EventDetails
{
    id: string;
    memberId: string;
    version: number;
    eventType: string;
    eventTypeIcon: string;
    eventTypeText: string;
    eventDateTime: any;
    eventEndDateTime: any;
    encounterType: string;
    encounterTypeText: string;
    appointment: any;
    facility: string;
    details: string;
    relevant: boolean;
    memberName: string;
    referral: any;
    referredFrom: any;
    referredTo: any;
    referredReason: string;
    referredDate: any;
    referredStartDate: any;
    referredEndDate: any;
    resource: any;
    resourceName: string;
    metricName: string;
}

export class Appointment
{
    public id: number;
    public version: number;
    public title: string;
    public allDay: boolean;
    public sendAppointmentToPatient: boolean;
    public npi: string;
    public provider: string;
    public timezoneOffset: number;
    public facilityId: number;
}

export class EventEdit
{
    public id: number;
    public memberId: number;
    public version: number;
    public eventDateTime: string;
    public eventEndDateTime: string;
    public details: string;
    public appointment: Appointment;

    constructor()
    {
        this.appointment = new Appointment();
    }
}
